// Centralized React Query keys for chain-backed hooks. Hooks read with the
// generated key, and event subscribers write to it via `setQueryData`. Keep
// keys stable: domain string + chainId + lowercased address — wagmi
// auto-generates its own keys per call but we override to a single shape so
// the event-driven `setQueryData` consistently lands in the same cache slot.

export const chainQueryKeys = {
    operatorLifetime: (chainId: number, address: string) =>
        ['chain', 'operatorLifetime', chainId, address.toLowerCase()] as const,
    kycRegistryRecord: (chainId: number, address: string) =>
        ['chain', 'kycRegistryRecord', chainId, address.toLowerCase()] as const,
    playerRegistryRecord: (chainId: number, address: string) =>
        ['chain', 'playerRegistryRecord', chainId, address.toLowerCase()] as const,
    kycPlayerGates: (chainId: number, address: string) =>
        ['chain', 'kycPlayerGates', chainId, address.toLowerCase()] as const,
    kycActivePolicy: (chainId: number) => ['chain', 'kycActivePolicy', chainId] as const,
}
